// extracted by mini-css-extract-plugin
export default {"companyAdminContainer":"CompanyAdmin_companyAdminContainer__TnBvD"};